export default "__VITE_ASSET__Ciip2GJ3__"